/**
 * Document types and the capture they require.
 *
 * Values mirror the IDV service contract exactly (DocumentType / CaptureMode /
 * CaptureSide in the proof of concept). Do not invent new values here: the
 * backend validates them.
 */

export const DOCUMENT_TYPES = [
  'identity_card',
  'driving_licence',
  'passport',
  'residence_permit',
];

export const CAPTURE_MODES = {
  FRONT_BACK_CARD: 'front_back_card',
  PASSPORT_DATA_PAGE: 'passport_data_page',
};

export const OVERLAY_TYPES = {
  CARD: 'card',
  PASSPORT: 'passport',
};

/** A passport is photographed on its data page only; everything else is a card. */
export function captureModeFor(documentType) {
  return documentType === 'passport'
    ? CAPTURE_MODES.PASSPORT_DATA_PAGE
    : CAPTURE_MODES.FRONT_BACK_CARD;
}

/**
 * Ordered sides to capture. Card-style documents need front and back; a
 * passport needs only its data page.
 */
export function requiredSidesFor(documentType) {
  return captureModeFor(documentType) === CAPTURE_MODES.PASSPORT_DATA_PAGE
    ? ['passport']
    : ['front', 'back'];
}

export function overlayTypeFor(side) {
  return side === 'passport' ? OVERLAY_TYPES.PASSPORT : OVERLAY_TYPES.CARD;
}

export function isSupportedDocumentType(documentType) {
  return DOCUMENT_TYPES.indexOf(documentType) !== -1;
}
